import * as actionTypes from './actionTypes';
import { photoVignetteService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const postPhotoVignetteRequest = () => ({
  type: actionTypes.POST_PHOTO_VIGNETTE_REQUEST
});

const postPhotoVignetteFailure = () => ({
  type: actionTypes.POST_PHOTO_VIGNETTE_FAILURE
});

const postPhotoVignetteSuccess = (id: number, data: any) => ({
  type: actionTypes.POST_PHOTO_VIGNETTE_SUCCESS,
  id,
  data
});

export const setPhotoVignetteAll = (data) => ({
  type: actionTypes.SET_PHOTO_VIGNETTE_ALL,
  data
})

export const clearPhotoVignette = (channelId: number) => ({
  type: actionTypes.CLEAR_PHOTO_VIGNETTE,
  id: channelId
});

export const clearPhotoVignetteAll = () => ({
  type: actionTypes.CLEAR_PHOTO_VIGNETTE_ALL
});

export const postPhotoVignette = (categoryId: number, channelId: number, json): Function => {
  return async dispatch => {
    dispatch(postPhotoVignetteRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await photoVignetteService.post(categoryId, json);
      if (data && data[0]) {
        dispatch(postPhotoVignetteSuccess(channelId, data[0]));
      }
    } catch (err) {
      dispatch(actionsModalError.openModalError('Intente nuevamente'));
      dispatch(postPhotoVignetteFailure());
    }
  }
};
